module.exports = __webpack_public_path__ + "static/WSC_Group_2019_Rental_Property_Tax_Checklist-7198c803f707574d814404734be666e4.pdf";